export const pageUrlGenerator = (page) =>
  `${window.location.protocol}//${window.location.host}${page}`;

export const SlotGames = {
  netenttab: {
    asgardianstones: {
      redirectUrl: "/casino/ezgne-asgardian-stones",
      code: "1100096",
      casino: "ezugi",
      imgUrl: "./images/slots/AsgardianStones-new.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Asgardian Stones",
      providerName: "slots",
    },
    secrets: {
      redirectUrl: "/casino/ezgne-secrets-of-atlantis",
      code: "1100106",
      casino: "ezugi",
      imgUrl: "./images/slots/SecretsofAtlantis.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Secrets of Atlantis",
      providerName: "slots",
    },
    SteamTower: {
      redirectUrl: "/casino/ezgne-steam-tower",
      code: "1100043",
      casino: "ezugi",
      imgUrl: "./images/slots/SteamTower.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Steam Tower",
      providerName: "slots",
    },
    DivinieFortuneMegaways: {
      redirectUrl: "/casino/ezgne-divine-fortune-megaways",
      code: "1100089",
      casino: "ezugi",
      imgUrl: "./images/slots/DivineFortuneMegaways.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Divine Fortune Megaways",
      providerName: "slots",
    },
    FruitShopMegaways: {
      redirectUrl: "/casino/ezgne-fruit-shop-megaways",
      code: "1100094",
      casino: "ezugi",
      imgUrl: "./images/slots/FruitShopMegaways.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Fruit Shop Megaways",
      providerName: "slots",
    },
    GorillaKingdom: {
      redirectUrl: "/casino/ezgne-gorilla-kingdom",
      code: "1100088",
      casino: "ezugi",
      imgUrl: "./images/slots/GorillaKingdom.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Gorilla Kingdom",
      providerName: "slots",
    },
    Christmas: {
      redirectUrl: "/casino/ezgne-aloha-christmas",
      code: "1100032",
      casino: "ezugi",
      imgUrl: "./images/slots/AlohaChristmas.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Aloha! Christmas",
      providerName: "slots",
    },
    ClusterPays: {
      redirectUrl: "/casino/ezgne-aloha-cluster-pays",
      code: "1100033",
      casino: "ezugi",
      imgUrl: "./images/slots/AlohaClusterPays.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Aloha! Cluster Pays",
      providerName: "slots",
    },
    WildWest: {
      redirectUrl: "/casino/ezgne-wild-wild-west-the-great-train-heist",
      code: "1100038",
      casino: "ezugi",
      imgUrl: "./images/slots/WildWildWestTheGreatTrainHeist.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Wild Wild West: The Great Train Heist",
      providerName: "slots",
    },
    TwinSpinMegaways: {
      redirectUrl: "/casino/ezgne-twin-spin-megaways",
      code: "1100039",
      casino: "ezugi",
      imgUrl: "./images/slots/twinspinmegaways.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Twin Spin Megaways",
      providerName: "slots",
    },
    TurnFortune: {
      redirectUrl: "/casino/ezgne-turn-your-fortune",
      code: "1100041",
      casino: "ezugi",
      imgUrl: "./images/slots/TurnYourFortune.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Turn Your Fortune",
      providerName: "slots",
    },
    Pyramid: {
      redirectUrl: "/casino/ezgne-pyramid-quest-for-immortality",
      code: "1100078",
      casino: "ezugi",
      imgUrl: "./images/slots/pyramidquestforimmortality.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Pyramid: Quest for Immortality",
      providerName: "slots",
    },
    PiggyRiches: {
      redirectUrl: "/casino/ezgne-piggy-riches",
      code: "1100080",
      casino: "ezugi",
      imgUrl: "./images/slots/Piggy-Riches.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Piggy Riches",
      providerName: "slots",
    },
    DarkKing: {
      redirectUrl: "/casino/ezgne-dark-king-forbidden-riches",
      code: "1100081",
      casino: "ezugi",
      imgUrl: "./images/slots/darkkingforbiddenriches-new.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Dark King: Forbidden Riches",
      providerName: "slots",
    },
    JingleSpin: {
      redirectUrl: "/casino/ezgne-jingle-spin",
      code: "1100082",
      casino: "ezugi",
      imgUrl: "./images/slots/jinglespin-new.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Jingle Spin",
      providerName: "slots",
    },
    JackHammer: {
      redirectUrl: "/casino/ezgne-jack-hammer",
      code: "1100084",
      casino: "ezugi",
      imgUrl: "./images/slots/Jackhammer-new.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Jack Hammer",
      providerName: "slots",
    },
    DeadorAlive: {
      redirectUrl: "/casino/ezgne-dead-or-alive",
      code: "1100085",
      casino: "ezugi",
      imgUrl: "./images/slots/Dead-or-Alive.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Dead or Alive",
      providerName: "slots",
    },
    DeadorAlive2: {
      redirectUrl: "/casino/ezgne-dead-or-alive-2",
      code: "1100087",
      casino: "ezugi",
      imgUrl: "./images/slots/Dead-or-Alive-2.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Dead or Alive 2",
      providerName: "slots",
    },
    JackandtheBeanstalk: {
      redirectUrl: "/casino/ezgne-jack-and-the-beanstalk",
      code: "1100086",
      casino: "ezugi",
      imgUrl: "./images/slots/Jack-and-the-Beanstalk.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Jack and the Beanstalk",
      providerName: "slots",
    },
    Elements: {
      redirectUrl: "/casino/ezgne-elements-the-awakening",
      code: "1100091",
      casino: "ezugi",
      imgUrl: "./images/slots/Elements-The-Awakening.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Elements: The Awakening",
      providerName: "slots",
    },
    FinnandtheSwirlySpin: {
      redirectUrl: "/casino/ezgne-finn-and-the-swirly-spin",
      code: "1100093",
      casino: "ezugi",
      imgUrl: "./images/slots/Finn-and-the-Swirly-Spin.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Finn and the Swirly Spin",
      providerName: "slots",
    },
    FruitShop: {
      redirectUrl: "/casino/ezgne-fruit-shop",
      code: "1100095",
      casino: "ezugi",
      imgUrl: "./images/slots/Fruit-Shop.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Fruit Shop",
      providerName: "slots",
    },
    // DeadorAlive2FeatureBuy: {
    //   redirectUrl: "/casino/ezgne-dead-or-alive-2-feature-buy",
    //   code: "1100100",
    //   casino: "ezugi",
    //   imgUrl: "./images/slots/DeadOrAlive2FeatureBuy.webp",
    //   homeUrl: pageUrlGenerator("/Slots"),
    //   name: "Dead or Alive 2 Feature Buy",
    //   providerName: "slots",
    // },
  },

  // redtigertab: {
  //   NinjaWays: {
  //     redirectUrl: "/casino/ezgrt-ninja-ways",
  //     code: "1100166",
  //     casino: "ezugi",
  //     imgUrl: "./images/slots/Ninja-Ways.webp",
  //     homeUrl: pageUrlGenerator("/Slots"),
  //     name: "Ninja Ways",
  //     providerName: "slots",
  //   },
  //   PathofDestiny: {
  //     redirectUrl: "/casino/ezgrt-path-of-destiny",
  //     code: "1100167",
  //     casino: "ezugi",
  //     imgUrl: "./images/slots/Path-of-Destiny.webp",
  //     homeUrl: pageUrlGenerator("/Slots"),
  //     name: "Path of Destiny",
  //     providerName: "slots",
  //   },
  //   PersianFortune: {
  //     redirectUrl: "/casino/ezgrt-persian-fortune",
  //     code: "1100168",
  //     casino: "ezugi",
  //     imgUrl: "./images/slots/Persian-Fortune.webp",
  //     homeUrl: pageUrlGenerator("/Slots"),
  //     name: "Persian Fortune",
  //     providerName: "slots",
  //   },
  //   ReelHeist: {
  //     redirectUrl: "/casino/ezgrt-reel-heist",
  //     code: "1100169",
  //     casino: "ezugi",
  //     imgUrl: "./images/slots/Reel-Heist.webp",
  //     homeUrl: pageUrlGenerator("/Slots"),
  //     name: "Reel Heist",
  //     providerName: "slots",
  //   },
  //   ReelKingMegaways: {
  //     redirectUrl: "/casino/ezgrt-reel-king-mega",
  //     code: "1100052",
  //     casino: "ezugi",
  //     imgUrl: "./images/slots/Reel_King_Mega.webp",
  //     homeUrl: pageUrlGenerator("/Slots"),
  //     name: "Reel King Mega",
  //     providerName: "slots",
  //   },
  //   RobinHoodWildForest: {
  //     redirectUrl: "/casino/ezgrt-robin-hoods-wild-forest",
  //     code: "1100170",
  //     casino: "ezugi",
  //     imgUrl: "./images/slots/Robin-Hood`s-Wild-Forest.webp",
  //     homeUrl: pageUrlGenerator("/Slots"),
  //     name: "Robin Hood`s Wild Forest",
  //     providerName: "slots",
  //   },
  //   SnowWild: {
  //     redirectUrl: "/casino/ezgrt-snow-wild-and-the-7-features",
  //     code: "1100171",
  //     casino: "ezugi",
  //     imgUrl: "./images/slots/Snow-Wild-And-The-7-Features.webp",
  //     homeUrl: pageUrlGenerator("/Slots"),
  //     name: "Snow Wild And The 7 Features",
  //     providerName: "slots",
  //   },
  //   SylvanSpirits: {
  //     redirectUrl: "/casino/ezgrt-sylvan-spirits",
  //     code: "1100172",
  //     casino: "ezugi",
  //     imgUrl: "./images/slots/Sylvan-Spirits.webp",
  //     homeUrl: pageUrlGenerator("/Slots"),
  //     name: "Sylvan Spirits",
  //     providerName: "slots",
  //   },
  //   TheGreatestTrainRobbery: {
  //     redirectUrl: "/casino/ezgrt-the-greatest-train-robbery",
  //     code: "1100173",
  //     casino: "ezugi",
  //     imgUrl: "./images/slots/The-Greatest-Train-Robbery.webp",
  //     homeUrl: pageUrlGenerator("/Slots"),
  //     name: "The Greatest Train Robbery",
  //     providerName: "slots",
  //   },
  //   TheWildHatter: {
  //     redirectUrl: "/casino/ezgrt-the-wild-hatter",
  //     code: "1100174",
  //     casino: "ezugi",
  //     imgUrl: "./images/slots/The-Wild-Hatter.webp",
  //     homeUrl: pageUrlGenerator("/Slots"),
  //     name: "The Wild Hatter",
  //     providerName: "slots",
  //   },
  //   ThorLightning: {
  //     redirectUrl: "/casino/ezgrt-thors-lightning",
  //     code: "1100175",
  //     casino: "ezugi",
  //     imgUrl: "./images/slots/Thor`s-Lightning.webp",
  //     homeUrl: pageUrlGenerator("/Slots"),
  //     name: "Thor`s Lightning",
  //     providerName: "slots",
  //   },
  //   DragonLuck: {
  //     redirectUrl: "/casino/ezgrt-dragons-luck",
  //     code: "1100001",
  //     casino: "ezugi",
  //     imgUrl: "./images/slots/Dragon's-Luck.webp",
  //     homeUrl: pageUrlGenerator("/Slots"),
  //     name: "Dragon's Luck",
  //     providerName: "slots",
  //   },
  //   DragonLuckReel: {
  //     redirectUrl: "/casino/ezgrt-dragons-luck-power-reels",
  //     code: "1100002",
  //     casino: "ezugi",
  //     imgUrl: "./images/slots/Dragon's-Luck-Power-Reels.webp",
  //     homeUrl: pageUrlGenerator("/Slots"),
  //     name: "Dragon's Luck Power Reels",
  //     providerName: "slots",
  //   },
  // },

  redtigertab: {
    DragonsLuck: {
      redirectUrl: "/casino/ezgrt-dragons-luck",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/DragonsLuck.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Dragon's Luck",
      providerName: "slots",
    },
    DragonsLuckPowerReels: {
      redirectUrl: "/casino/ezgrt-dragons-luck-power-reels",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/DragonsLuckPowerReels.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Dragon's Luck Power Reels",
      providerName: "slots",
    },
    Nights10001: {
      redirectUrl: "/casino/ezgrt-10001-nights",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/10001Nights.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "10,001 Nights",
      providerName: "slots",
    },
    GodOfWealth: {
      redirectUrl: "/casino/ezgrt-god-of-wealth",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/GodOfwealth-new.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "God Of Wealth",
      providerName: "slots",
    },
    PiratesPlentyBattleforGold: {
      redirectUrl: "/casino/ezgrt-pirates-plenty-battle-for-gold",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/PiratesPlentyBattleforGold.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Pirates' Plenty Battle for Gold",
      providerName: "slots",
    },
    ChineseTreasures: {
      redirectUrl: "/casino/ezgrt-chinese-treasures",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/chinesetreasure-new.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Chinese Treasures",
      providerName: "slots",
    },
    FortuneHouse: {
      redirectUrl: "/casino/ezgrt-fortune-house",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/FortuneHouse.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Fortune House",
      providerName: "slots",
    },
    DragonsFire: {
      redirectUrl: "/casino/ezgrt-dragons-fire",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/DragonsFire.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Dragon's Fire",
      providerName: "slots",
    },
    MagicGate: {
      redirectUrl: "/casino/ezgrt-magic-gate",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/MagicGate.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Magic Gate",
      providerName: "slots",
    },
    LuckyFortuneCat: {
      redirectUrl: "/casino/ezgrt-lucky-fortune-cat",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/LuckyFortuneCat.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Lucky Fortune Cat",
      providerName: "slots",
    },
    DragonsLuckDeluxe: {
      redirectUrl: "/casino/ezgrt-dragons-luck-deluxe",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/DragonsLuckDeluxe.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Dragon's Luck Deluxe",
      providerName: "slots",
    },
    EpicJourney: {
      redirectUrl: "/casino/ezgrt-epic-journey",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/EpicJourney.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Epic Journey",
      providerName: "slots",
    },
    PhoenixFirePowerReels: {
      redirectUrl: "/casino/ezgrt-phoenix-fire-power-reels",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/PhoenixFirePowerReels.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Phoenix Fire Power Reels",
      providerName: "slots",
    },
    GoldenTemple: {
      redirectUrl: "/casino/ezgrt-golden-temple",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/GoldenTemple.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Golden Temple",
      providerName: "slots",
    },
    PiratesPlenty: {
      redirectUrl: "/casino/ezgrt-pirates-plenty",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/PiratesPlenty.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Pirates' Plenty",
      providerName: "slots",
    },
    GoldenOffer: {
      redirectUrl: "/casino/ezgrt-golden-offer",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/GoldenOffer.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Golden Offer",
      providerName: "slots",
    },
    RAsLegend: {
      redirectUrl: "/casino/ezgrt-ras-legend",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/RAsLegend.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "RA's Legend",
      providerName: "slots",
    },
    GonzosQuestMegaways: {
      redirectUrl: "/casino/ezgrt-gonzos-quest-megaways",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/GonzosQuestMegaways.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Gonzo's Quest Megaways",
      providerName: "slots",
    },
    RainbowJackpots: {
      redirectUrl: "/casino/ezgrt-rainbow-jackpots",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/RainbowJackpots.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Rainbow Jackpots",
      providerName: "slots",
    },
    MegaPyramid: {
      redirectUrl: "/casino/ezgrt-mega-pyramid",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/MegaPyramid.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Mega Pyramid",
      providerName: "slots",
    },
    WarOfGods: {
      redirectUrl: "/casino/ezgrt-war-of-gods",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/WarOfGods.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "War Of Gods",
      providerName: "slots",
    },
    Strike777: {
      redirectUrl: "/casino/ezgrt-777-strike",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/777Strike.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "777 Strike",
      providerName: "slots",
    },
    AncientsBlessing: {
      redirectUrl: "/casino/ezgrt-ancients-blessing",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/AncientsBlessing.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Ancients Blessing",
      providerName: "slots",
    },
    AurumCodex: {
      redirectUrl: "/casino/ezgrt-aurum-codex",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/AurumCodex.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Aurum Codex",
      providerName: "slots",
    },
    BettyBorisandBoo: {
      redirectUrl: "/casino/ezgrt-betty-boris-and-boo",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/BettyBorisandBoo.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Betty, Boris and Boo",
      providerName: "slots",
    },
    // ZeusLightningPowerReels: {
    //   redirectUrl: "/casino/ezgrt-zeus-lightning-power-reels",
    //   code: "",
    //   casino: "ezugi",
    //   imgUrl: "./images/slots/new/redtiger/ZeusLightningPower-Reels.webp",
    //   homeUrl: pageUrlGenerator("/Slots"),
    //   name: "Zeus Lightning Power Reels",
    //   providerName: "slots",
    // },
    WingsofRa: {
      redirectUrl: "/casino/ezgrt-wings-of-ra",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/WingsofRa.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Wings of Ra",
      providerName: "slots",
    },
    TreasureMine: {
      redirectUrl: "/casino/ezgrt-treasure-mine",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/TreasureMine.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Treasure Mine",
      providerName: "slots",
    },
    ThorsVengeance: {
      redirectUrl: "/casino/ezgrt-thors-vengeance",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/ThorsVengeance.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Thor's Vengeance",
      providerName: "slots",
    },
    RegalStreak: {
      redirectUrl: "/casino/ezgrt-regal-streak",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/RegalStreak.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Regal Streak",
      providerName: "slots",
    },
    RegalBeasts: {
      redirectUrl: "/casino/ezgrt-regal-beasts",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/RegalBeasts.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Regal Beasts",
      providerName: "slots",
    },
    ReelKingMega: {
      redirectUrl: "/casino/ezgrt-reel-king-mega",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/ReelKingMega.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Reel King Mega",
      providerName: "slots",
    },
    ReelKeeper: {
      redirectUrl: "/casino/ezgrt-reel-keeper",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/ReelKeeper.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Reel Keeper",
      providerName: "slots",
    },
    RainbowJackpotsPowerLines: {
      redirectUrl: "/casino/ezgrt-rainbow-jackpots-power-lines",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/RainbowJackpotsPowerLines.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Rainbow Jackpots Power Lines",
      providerName: "slots",
    },
    MysteryReels: {
      redirectUrl: "/casino/ezgrt-mystery-reels",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/MysteryReels.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Mystery Reels",
      providerName: "slots",
    },
    PiggyRichesMegaways: {
      redirectUrl: "/casino/ezgrt-piggy-riches-megaways",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/PiggyRichesMegaways.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Piggy Riches Megaways",
      providerName: "slots",
    },
    JingleBells: {
      redirectUrl: "/casino/ezgrt-jingle-bells",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/JingleBells.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Jingle Bells",
      providerName: "slots",
    },
    JackinaPot: {
      redirectUrl: "/casino/ezgrt-jack-in-a-pot",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/JackinaPot.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Jack in a Pot",
      providerName: "slots",
    },
    FiveStar: {
      redirectUrl: "/casino/ezgrt-five-star",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/FiveStar.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Five Star",
      providerName: "slots",
    },
    BountyRaid: {
      redirectUrl: "/casino/ezgrt-bounty-raid",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/BountyRaid.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Bounty Raid",
      providerName: "slots",
    },
    CashUltimate: {
      redirectUrl: "/casino/ezgrt-cash-ultimate",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/CashUltimate.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Cash Ultimate",
      providerName: "slots",
    },
    CashVolt: {
      redirectUrl: "/casino/ezgrt-cash-volt",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/CashVolt.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Cash Volt",
      providerName: "slots",
    },
    DynamiteRiches: {
      redirectUrl: "/casino/ezgrt-dynamite-riches",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/DynamiteRiches.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Dynamite Riches",
      providerName: "slots",
    },
    DiamondBlitz: {
      redirectUrl: "/casino/ezgrt-diamond-blitz",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/DiamondBlitz.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Diamond Blitz",
      providerName: "slots",
    },
    DragonsFireMegaways: {
      redirectUrl: "/casino/ezgrt-dragons-fire-megaways",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/DragonsFireMegaways.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Dragon's Fire Megaways",
      providerName: "slots",
    },
    Squad4: {
      redirectUrl: "/casino/ezgrt-4-squad",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/4Squad.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "4 Squad",
      providerName: "slots",
    },
    AgentRoyale: {
      redirectUrl: "/casino/ezgrt-agent-royale",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/AgentRoyale.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Agent Royale",
      providerName: "slots",
    },
    Families5: {
      redirectUrl: "/casino/ezgrt-5-families",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/5Families.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "5 Families",
      providerName: "slots",
    },
    ArcadeBomb: {
      redirectUrl: "/casino/ezgrt-arcade-bomb",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/ArcadeBomb.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Arcade Bomb",
      providerName: "slots",
    },
    CinderellasBall: {
      redirectUrl: "/casino/ezgrt-cinderellas-ball",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/CinderellasBall.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Cinderella`s Ball",
      providerName: "slots",
    },
    Atlantis: {
      redirectUrl: "/casino/ezgrt-atlantis",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/Atlantis.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Atlantis",
      providerName: "slots",
    },
    AztecSpins: {
      redirectUrl: "/casino/ezgrt-aztec-spins",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/AztecSpins.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Aztec Spins",
      providerName: "slots",
    },
    ClashoftheBeasts: {
      redirectUrl: "/casino/ezgrt-clash-of-the-beasts",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/ClashoftheBeasts.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Clash of the Beasts",
      providerName: "slots",
    },
    CirquedelaFortune: {
      redirectUrl: "/casino/ezgrt-cirque-de-la-fortune",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/CirquedelaFortune.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Cirque de la Fortune",
      providerName: "slots",
    },
    CrazyGenie: {
      redirectUrl: "/casino/ezgrt-crazy-genie",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/CrazyGenie.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Crazy Genie",
      providerName: "slots",
    },
    CrystalMirror: {
      redirectUrl: "/casino/ezgrt-crystal-mirror",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/CrystalMirror.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Crystal Mirror",
      providerName: "slots",
    },
    DevilsNumber: {
      redirectUrl: "/casino/ezgrt-devils-number",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/DevilsNumber.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Devil`s Number",
      providerName: "slots",
    },
    DaVincisMystery: {
      redirectUrl: "/casino/ezgrt-da-vincis-mystery",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/DaVincisMystery.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Da Vinci`s Mystery",
      providerName: "slots",
    },
    DiceDiceDice: {
      redirectUrl: "/casino/ezgrt-dice-dice-dice",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/DiceDiceDice.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Dice Dice Dice",
      providerName: "slots",
    },
    FiveStarsPowerReels: {
      redirectUrl: "/casino/ezgrt-five-stars-power-reels",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/FiveStarsPowerReels.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Five Stars Power Reels",
      providerName: "slots",
    },
    GemsGoneWild: {
      redirectUrl: "/casino/ezgrt-gems-gone-wild",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/GemsGoneWild.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Gems Gone Wild",
      providerName: "slots",
    },
    GemsGoneWildPowerReels: {
      redirectUrl: "/casino/ezgrt-gems-gone-wild-power-reels",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/GemsGoneWildPowerReels.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Gems Gone Wild Power Reels",
      providerName: "slots",
    },
    GoldenCryptex: {
      redirectUrl: "/casino/ezgrt-golden-cryptex",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/GoldenCryptex.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Golden Cryptex",
      providerName: "slots",
    },
    GoldenLeprechaunMegaways: {
      redirectUrl: "/casino/ezgrt-golden-leprechaun-megaways",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/GoldenLeprechaunMegaways.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Golden Leprechaun Megaways",
      providerName: "slots",
    },
    GrandWheel: {
      redirectUrl: "/casino/ezgrt-grand-wheel",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/GrandWheel.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Grand Wheel",
      providerName: "slots",
    },
    GoldenTsar: {
      redirectUrl: "/casino/ezgrt-golden-tsar",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/GoldenTsar.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Golden Tsar",
      providerName: "slots",
    },
    HoardofPoseidon: {
      redirectUrl: "/casino/ezgrt-hoard-of-poseidon",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/HoardofPoseidon.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Hoard of Poseidon",
      providerName: "slots",
    },
    JewelScarabs: {
      redirectUrl: "/casino/ezgrt-jewel-scarabs",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/JewelScarabs.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Jewel Scarabs",
      providerName: "slots",
    },
    LegendofAthena: {
      redirectUrl: "/casino/ezgrt-legend-of-athena",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/LegendofAthena.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Legend of Athena",
      providerName: "slots",
    },
    JingleBellsPowerReels: {
      redirectUrl: "/casino/ezgrt-jingle-bells-power-reels",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/JingleBellsPowerReels.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Jingle Bells Power Reels",
      providerName: "slots",
    },
    LuckyHalloween: {
      redirectUrl: "/casino/ezgrt-lucky-halloween",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/LuckyHalloween.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Lucky Halloween",
      providerName: "slots",
    },
    LuckyLittleDevil: {
      redirectUrl: "/casino/ezgrt-lucky-little-devil",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/LuckyLittleDevil.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Lucky Little Devil",
      providerName: "slots",
    },
    LuckyValentine: {
      redirectUrl: "/casino/ezgrt-lucky-valentine",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/LuckyValentine.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Lucky Valentine",
      providerName: "slots",
    },
    LuckyWizard: {
      redirectUrl: "/casino/ezgrt-lucky-wizard",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/LuckyWizard.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Lucky Wizard",
      providerName: "slots",
    },
    Masquerade: {
      redirectUrl: "/casino/ezgrt-masquerade",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/Masquerade.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Masquerade",
      providerName: "slots",
    },
    MayanGods: {
      redirectUrl: "/casino/ezgrt-mayan-gods",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/MayanGods.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Mayan Gods",
      providerName: "slots",
    },
    MegaDragon: {
      redirectUrl: "/casino/ezgrt-mega-dragon",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/MegaDragon.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Mega Dragon",
      providerName: "slots",
    },
    MegaJade: {
      redirectUrl: "/casino/ezgrt-mega-jade",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/MegaJade.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Mega Jade",
      providerName: "slots",
    },
    MegaRise: {
      redirectUrl: "/casino/ezgrt-mega-rise",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/MegaRise.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Mega Rise",
      providerName: "slots",
    },
    MultiplierRiches: {
      redirectUrl: "/casino/ezgrt-multiplier-riches",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/MultiplierRiches.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Multiplier Riches",
      providerName: "slots",
    },
    MysteryReelsMegaways: {
      redirectUrl: "/casino/ezgrt-mystery-reels-megaways",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/MysteryReelsMegaways.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Mystery Reels Megaways",
      providerName: "slots",
    },
    NinjaWays: {
      redirectUrl: "/casino/ezgrt-ninja-ways",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Ninja Ways",
      providerName: "slots",
    },
    PathofDestiny: {
      redirectUrl: "/casino/ezgrt-path-of-destiny",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/PathofDestiny.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Path of Destiny",
      providerName: "slots",
    },
    PersianFortune: {
      redirectUrl: "/casino/ezgrt-persian-fortune",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/PersianFortune.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Persian Fortune",
      providerName: "slots",
    },
    ReelHeist: {
      redirectUrl: "/casino/ezgrt-reel-heist",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/ReelHeist.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Reel Heist",
      providerName: "slots",
    },
    RobinHoodsWildForest: {
      redirectUrl: "/casino/ezgrt-robin-hoods-wild-forest",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/RobinHoodsWildForest.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Robin Hood`s Wild Forest",
      providerName: "slots",
    },
    SnowWildAndThe7Features: {
      redirectUrl: "/casino/ezgrt-snow-wild-and-the-7-features",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/SnowWildAndThe7Features.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Snow Wild And The 7 Features",
      providerName: "slots",
    },
    SylvanSpirits: {
      redirectUrl: "/casino/ezgrt-sylvan-spirits",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/SylvanSpirits.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Sylvan Spirits",
      providerName: "slots",
    },
    TheGreatestTrainRobbery: {
      redirectUrl: "/casino/ezgrt-the-greatest-train-robbery",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/TheGreatestTrainRobbery.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "The Greatest Train Robbery",
      providerName: "slots",
    },
    TheWildHatter: {
      redirectUrl: "/casino/ezgrt-the-wild-hatter",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/TheWildHatter.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "The Wild Hatter",
      providerName: "slots",
    },
    ThorsLightning: {
      redirectUrl: "/casino/ezgrt-thors-lightning",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/ThorsLightning.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Thor`s Lightning",
      providerName: "slots",
    },
    TikiFruits: {
      redirectUrl: "/casino/ezgrt-tiki-fruits",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/TikiFruits.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Tiki Fruits",
      providerName: "slots",
    },
    VaultCracker: {
      redirectUrl: "/casino/ezgrt-vault-cracker",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/VaultCracker.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Vault Cracker",
      providerName: "slots",
    },
    TotemLightning: {
      redirectUrl: "/casino/ezgrt-totem-lightning",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/TotemLightning.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Totem Lightning",
      providerName: "slots",
    },
    WellofWishes: {
      redirectUrl: "/casino/ezgrt-well-of-wishes",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/WellofWishes.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Well of Wishes",
      providerName: "slots",
    },
    VaultofAnubis: {
      redirectUrl: "/casino/ezgrt-vault-of-anubis",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/VaultofAnubis.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Vault of Anubis",
      providerName: "slots",
    },
    WildOClock: {
      redirectUrl: "/casino/ezgrt-wild-oclock",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/WildOClock.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Wild O`Clock",
      providerName: "slots",
    },
    WildCatsMultiline: {
      redirectUrl: "/casino/ezgrt-wild-cats-multiline",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/WildCatsMultiline.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Wild Cats Multiline",
      providerName: "slots",
    },
    YucatansMystery: {
      redirectUrl: "/casino/ezgrt-yucatans-mystery",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/YucatansMystery.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Yucatan`s Mystery",
      providerName: "slots",
    },
    WildWildChest: {
      redirectUrl: "/casino/ezgrt-wild-wild-chest",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/WildWildChest.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Wild Wild Chest",
      providerName: "slots",
    },
    WinEscalator: {
      redirectUrl: "/casino/ezgrt-win-escalator",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/WinEscalator.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Win Escalator",
      providerName: "slots",
    },
  },

  homepageSlots: {
    ReelHeist: {
      redirectUrl: "/casino/ezgrt-reel-heist",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/Reel-Heist.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Reel Heist",
      providerName: "slots",
    },
    RobinHoodsWildForest: {
      redirectUrl: "/casino/ezgrt-robin-hoods-wild-forest",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/Robin-Hoods-Wild-Forest.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Robin Hood`s Wild Forest",
      providerName: "slots",
    },
    SnowWildAndThe7Features: {
      redirectUrl: "/casino/ezgrt-snow-wild-and-the-7-features",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/Snow-Wild-And-The-7-Features.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Snow Wild And The 7 Features",
      providerName: "slots",
    },
    SylvanSpirits: {
      redirectUrl: "/casino/ezgrt-sylvan-spirits",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/Sylvan-Spirits.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Sylvan Spirits",
      providerName: "slots",
    },
    TheGreatestTrainRobbery: {
      redirectUrl: "/casino/ezgrt-the-greatest-train-robbery",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/The-Greatest-Train-Robbery.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "The Greatest Train Robbery",
      providerName: "slots",
    },
    TheWildHatter: {
      redirectUrl: "/casino/ezgrt-the-wild-hatter",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/The-Wild-Hatter.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "The Wild Hatter",
      providerName: "slots",
    },
    ThorsLightning: {
      redirectUrl: "/casino/ezgrt-thors-lightning",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/Thors-Lightning.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Thor`s Lightning",
      providerName: "slots",
    },
    TikiFruits: {
      redirectUrl: "/casino/ezgrt-tiki-fruits",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/tikkifruits.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Tiki Fruits",
      providerName: "slots",
    },
    VaultCracker: {
      redirectUrl: "/casino/ezgrt-vault-cracker",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/vaultcrackers.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Vault Cracker",
      providerName: "slots",
    },
    TotemLightning: {
      redirectUrl: "/casino/ezgrt-totem-lightning",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/totemlightning.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Totem Lightning",
      providerName: "slots",
    },
    WellofWishes: {
      redirectUrl: "/casino/ezgrt-well-of-wishes",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/wellwishes.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Well of Wishes",
      providerName: "slots",
    },
    VaultofAnubis: {
      redirectUrl: "/casino/ezgrt-vault-of-anubis",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/vaultofanbis.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Vault of Anubis",
      providerName: "slots",
    },
    WildOClock: {
      redirectUrl: "/casino/ezgrt-wild-oclock",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/SlotsNew/WildOClock.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Wild O`Clock",
      providerName: "slots",
    },
    WildCatsMultiline: {
      redirectUrl: "/casino/ezgrt-wild-cats-multiline",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/SlotsNew/WildCatsMultiline.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Wild Cats Multiline",
      providerName: "slots",
    },
    YucatansMystery: {
      redirectUrl: "/casino/ezgrt-yucatans-mystery",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/SlotsNew/yucatansmystery.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Yucatan`s Mystery",
      providerName: "slots",
    },
    WildWildChest: {
      redirectUrl: "/casino/ezgrt-wild-wild-chest",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/SlotsNew/WildWildChest.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Wild Wild Chest",
      providerName: "slots",
    },
    WinEscalator: {
      redirectUrl: "/casino/ezgrt-win-escalator",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/SlotsNew/WinEscalator.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Win Escalator",
      providerName: "slots",
    },
    GodOfWealth: {
      redirectUrl: "/casino/ezgrt-god-of-wealth",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/SlotsNew/GodOfWealth.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "God Of Wealth",
      providerName: "slots",
    },
    asgardianstones: {
      redirectUrl: "/casino/ezgne-asgardian-stones",
      code: "1100096",
      casino: "ezugi",
      imgUrl: "./images/slots/SlotsNew/asgardianstones.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Asgardian Stones",
      providerName: "slots",
    },
    secrets: {
      redirectUrl: "/casino/ezgne-secrets-of-atlantis",
      code: "1100106",
      casino: "ezugi",
      imgUrl: "./images/slots/SlotsNew/secretsofatlantis.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Secrets of Atlantis",
      providerName: "slots",
    },
    SteamTower: {
      redirectUrl: "/casino/ezgne-steam-tower",
      code: "1100043",
      casino: "ezugi",
      imgUrl: "./images/slots/SlotsNew/SteamTower.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Steam Tower",
      providerName: "slots",
    },
    DivinieFortuneMegaways: {
      redirectUrl: "/casino/ezgne-divine-fortune-megaways",
      code: "1100089",
      casino: "ezugi",
      imgUrl: "./images/slots/SlotsNew/DivineFortunemegaways.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Divine Fortune Megaways",
      providerName: "slots",
    },
    FruitShopMegaways: {
      redirectUrl: "/casino/ezgne-fruit-shop-megaways",
      code: "1100094",
      casino: "ezugi",
      imgUrl: "./images/slots/SlotsNew/Fruitshopmegaways.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Fruit Shop Megaways",
      providerName: "slots",
    },
    GorillaKingdom: {
      redirectUrl: "/casino/ezgne-gorilla-kingdom",
      code: "1100088",
      casino: "ezugi",
      imgUrl: "./images/slots/SlotsNew/GorillaKingdom.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Gorilla Kingdom",
      providerName: "slots",
    },
    Christmas: {
      redirectUrl: "/casino/ezgne-aloha-christmas",
      code: "1100032",
      casino: "ezugi",
      imgUrl: "./images/slots/SlotsNew/Alohachristmas.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Aloha! Christmas",
      providerName: "slots",
    },
    ClusterPays: {
      redirectUrl: "/casino/ezgne-aloha-cluster-pays",
      code: "1100033",
      casino: "ezugi",
      imgUrl: "./images/slots/SlotsNew/Alohachristmaspays.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Aloha! Cluster Pays",
      providerName: "slots",
    },
    WildWest: {
      redirectUrl: "/casino/ezgne-wild-wild-west-the-great-train-heist",
      code: "1100038",
      casino: "ezugi",
      imgUrl: "./images/slots/SlotsNew/WildWildWestthegreattrainheist.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Wild Wild West: The Great Train Heist",
      providerName: "slots",
    },
    TwinSpinMegaways: {
      redirectUrl: "/casino/ezgne-twin-spin-megaways",
      code: "1100039",
      casino: "ezugi",
      imgUrl: "./images/slots/SlotsNew/TwinSpinMegaways.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Twin Spin Megaways",
      providerName: "slots",
    },
    TurnFortune: {
      redirectUrl: "/casino/ezgne-turn-your-fortune",
      code: "1100041",
      casino: "ezugi",
      imgUrl: "./images/slots/SlotsNew/TurnYourFortune.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Turn Your Fortune",
      providerName: "slots",
    },
    Pyramid: {
      redirectUrl: "/casino/ezgne-pyramid-quest-for-immortality",
      code: "1100078",
      casino: "ezugi",
      imgUrl: "./images/slots/SlotsNew/pyramidquestforimmortality.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Pyramid: Quest for Immortality",
      providerName: "slots",
    },
  },


  anviogames: {
    Zhandu: {
      redirectUrl: "/casino/anvioanvio-zhandu",
      code: "",
      casino: "anvio",
      imgUrl: "./images/anvio-games/Zandu.jpg",
      homeUrl: pageUrlGenerator("/"),
      name: "Zhandu",
      providerName: "Anvio",
    },
    Teenpatti: {
      redirectUrl: "/casino/anvioanvio-teenpatti",
      code: "",
      casino: "Anvio",
      imgUrl: "./images/anvio-games/Teenpatti.jpg",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Teenpatti",
      providerName: "Anvio",
    },
    DragonTiger: {
      redirectUrl: "/casino/anvioanvio-dragon-tiger",
      code: "",
      casino: "Anvio",
      imgUrl: "./images/anvio-games/DragonTiger.jpg",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Dragon Tiger",
      providerName: "Anvio",
    },
    Dana: {
      redirectUrl: "/casino/anvioanvio-dana",
      code: "",
      casino: "Anvio",
      imgUrl: "./images/anvio-games/Dana.jpg",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Dana",
      providerName: "Anvio",
    },
  }
};
